module.exports = __webpack_public_path__ + "static/net-7a1a17a918d1761e671be0caf37c36fa.png";